/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const it_search_preview_content_no_results = /** @type {(inputs: {}) => string} */ () => {
	return `Non abbiamo trovato risultati corrispondenti`
};

const en_search_preview_content_no_results = /** @type {(inputs: {}) => string} */ () => {
	return `No matching results found`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "it" | "en" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const search_preview_content_no_results = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.search_preview_content_no_results(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("search_preview_content_no_results", locale)
	if (locale === "it") return it_search_preview_content_no_results(inputs)
	return en_search_preview_content_no_results(inputs)
};
export { search_preview_content_no_results as "search-preview-content.no-results" }